import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleGuide from "../pages/articles/guide/page";
import ShoppingGuide from "../pages/shopping-guide/page";
import YoybuyVsSuperbuy from "../pages/articles/yoybuy-vs-superbuy/page";
import ChinaSpreadsheetAgent from "../pages/articles/china-spreadsheet-agent/page";
import HowToOrder1688 from "../pages/articles/how-to-order-1688/page";
import SpreadsheetFees from "../pages/articles/spreadsheet-fees/page";
import SpreadsheetSafety from "../pages/articles/spreadsheet-safety/page";
import DropshippingSpreadsheet from "../pages/articles/dropshipping-spreadsheet/page";
import BestChinaAgent from "../pages/articles/best-china-agent/page";
import TaobaoSpreadsheet from "../pages/articles/taobao-spreadsheet/page";
import KakobuyVsYoybuy from "../pages/articles/kakobuy-vs-yoybuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuide />,
  },
  {
    path: "/articles/yoybuy-spreadsheet-guide",
    element: <ArticleGuide />,
  },
  {
    path: "/articles/yoybuy-vs-superbuy",
    element: <YoybuyVsSuperbuy />,
  },
  {
    path: "/articles/china-spreadsheet-agent",
    element: <ChinaSpreadsheetAgent />,
  },
  {
    path: "/articles/how-to-order-1688",
    element: <HowToOrder1688 />,
  },
  {
    path: "/articles/spreadsheet-fees",
    element: <SpreadsheetFees />,
  },
  {
    path: "/articles/spreadsheet-safety",
    element: <SpreadsheetSafety />,
  },
  {
    path: "/articles/dropshipping-spreadsheet",
    element: <DropshippingSpreadsheet />,
  },
  {
    path: "/articles/best-china-agent",
    element: <BestChinaAgent />,
  },
  {
    path: "/articles/taobao-spreadsheet",
    element: <TaobaoSpreadsheet />,
  },
  {
    path: "/articles/kakobuy-vs-yoybuy",
    element: <KakobuyVsYoybuy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;